<template>
  <div class="enterprise">
    <el-form :model="queryInfo" class="ly-header__bg" label-width="100px">
      <el-form-item label="行业类别：">
        <SelectTreeRadio
          :isTree="true"
          apiName="getIndustryThree"
          resultType="values"
          storageKey="industryCategory"
          v-model="queryInfo.industryTag"
          @input="e => labelTagChange('industryTag', e, '技术类别')"
        ></SelectTreeRadio>
      </el-form-item>

      <el-form-item label="方案类型：">
        <SelectTreeRadio
          apiName="getDicRadioButton"
          :params="{ code: '051' }"
          resultType="values"
          vFeild="codeId"
          lFeild="codeName"
          storageKey="solutionCategory"
          v-model="queryInfo.solutionType"
          @input="e => labelTagChange('solutionType', e, '方案类型')"
        ></SelectTreeRadio>
      </el-form-item>

      <el-form-item label="交付类型：">
        <SelectTreeRadio
          :isTree="true"
          apiName="getDicRadioButton"
          :params="{ code: '008' }"
          resultType="values"
          vFeild="codeId"
          lFeild="codeName"
          storageKey="deliverCategory"
          v-model="queryInfo.deliveryType"
          @input="e => labelTagChange('deliveryType', e, '交付类型')"
        ></SelectTreeRadio>
      </el-form-item>

      <el-form-item label="筛选条件：" class="filterInfo">
        <el-tag
          closable
          v-for="(item, index) in tags"
          :key="index + item.name"
          @close="closeTag(index, item)"
        >
          {{ item.name }}：{{
            item.field ? item.field : "不限"
          }}
          <span
            class="circle"
            v-if="item.hasOwnProperty('valLength') && item.valLength > 0"
            >+{{ item.valLength }}</span
          >
        </el-tag>
      </el-form-item>
    </el-form>

    <div class="ly-container__bg">
      <div class="ly_operation">
        <div class="left">
          <!-- <el-button type="primary" icon="jr-iconjr-icon-add" @click="addItem"
            >添加</el-button
          > -->

          <import-data @fileClick="fileClick" moduleName="企业数据" buttonText="批量上传" buttonType="primary"/>

          <el-button @click="multiDelete">
            批量删除
            <i class="jr-iconjr-icon-delect" />
          </el-button>

          <popover @popoverClick="popoverClick" />

          <div class="upload_time">
            <div @click="caretText" class="caretTime">按创建时间</div>
            <div class="upload_time_icon">
              <i
                class="el-icon-caret-top"
                :class="[
                  queryInfo.columnName == 'creation_time' && queryInfo.order == 0
                    ? 'isActiveTime'
                    : 'iconColor'
                ]"
                @click="caretTop"
              />
              <i
                class="el-icon-caret-bottom"
                :class="[
                  queryInfo.columnName == 'creation_time' && queryInfo.order == 1
                    ? 'isActiveTime'
                    : 'iconColor'
                ]"
                @click="caretBottom"
              />
            </div>
          </div>
        </div>

        <MySearchInput
          placeholderTxt="根据名称/标签搜索"
          v-model="queryInfo.queryConditions"
          @on-search="search"
          @on-clear="search"
          @on-enter="search"
        ></MySearchInput>
      </div>

      <el-table
        class="ly_table"
        :data="enterpriseTable"
        :header-cell-style="{ background: '#F5F6F7', color: '#363E4D' }"
        @selection-change="handleSelectionChange"
        :cell-style="set_cell_style"
        @sort-change="sortChange"
        style="width: 100%"
      >
        <template slot="empty">
          <img src="@/assets/img/table.png" alt="没有数据" srcset />
        </template>

        <el-table-column type="selection" width="55" align="center" />

        <el-table-column
          label="编号"
          prop="id"
          align="center"
          width="100"
        ></el-table-column>

        <el-table-column
          prop="solutionDataIntegrity"
          label="数据完整度"
          sortable="custom"
          align="center"
          width="120"
        >
          <template v-slot="{ row }">
            <div @click="editItem(row)" style="cursor: pointer">
              <el-progress
                type="circle"
                :percentage="row.solutionDataIntegrity ? Number(row.solutionDataIntegrity) : 0"
                :stroke-width="12"
              ></el-progress>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="dataQuality"
          label="数据质量"
          align="center"
          width="150"
        >
        </el-table-column>

        <el-table-column label="解决方案名称" prop="solutionName" align="center"></el-table-column>

        <el-table-column
          prop="companyLogoLook"
          label="封面图"
          align="center"
          width="100"
        >
          <template v-slot="{ row }">
            <div
              @click="editItem(row)"
              style="cursor: pointer"
              v-if="row.coverImage"
            >
              <el-image :src="row.coverImage" class="headerImg" />
            </div>

            <div @click="editItem(row)" style="cursor: pointer" v-else>
              <el-image
                :src="require('../../assets/img/pro.png')"
                class="headerImg"
              />
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="解决方案类型"
          prop="solutionType"
          align="center"
          width="180"
        ></el-table-column>

        <el-table-column label="所属企业" prop="comName" align="center"></el-table-column>

        <el-table-column
          prop="updateTime"
          label="修改时间"
          align="center"
          width="100"
          :formatter="formatTime"
        ></el-table-column>

        <el-table-column
          prop="createName"
          label="创建人"
          align="center"
          width="80"
        ></el-table-column>

        <el-table-column
          prop="creationTime"
          label="创建时间"
          align="center"
          width="120"
          :formatter="formatTime"
        ></el-table-column>

        <el-table-column label="操作" width="150" align="center">
          <template v-slot="{ row }">
            <button-table
              content="下载"
              @buttonClick="downloadClick(row)"
              icon="jr-iconjr-icon-download"
            />

            <button-table
              @buttonClick="editItem(row)"
              content="编辑"
              icon="jr-iconjr-icon-edit"
            />
            <button-table
              @buttonClick="deleteItem(row)"
              content="删除"
              icon="jr-iconjr-icon-delect"
            />
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 30, 50, 100, 200]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import DicCheckboxGroup from "@/components/DicCheckboxGroup.vue";
import Popover from "@/components/Popover.vue";
import ImportData from "@/components/ImportData.vue";
import ButtonTable from "@/components/ButtonTable.vue";
import DicTagButton from "@/components/DicTagButton.vue";
import DicRadioButton from "@/components/DicRadioButton.vue";
import CascaderArea from "@/components/CascaderAreaEnter.vue";
import { getCompanyList, deleteCompany } from "@/api/enterprise";
import { exportData } from "@/utils/tool";
import { pagination } from "@/mixins/pagination";
// api
import { getSolutionList, deleteSolutionById } from "@/api/solvePlan.js";

// 多级标签
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
export default {
  mixins: [pagination],

  components: {
    ButtonTable,
    ImportData,
    DicRadioButton,
    DicTagButton,
    DicCheckboxGroup,
    CascaderArea,
    Popover,
    SelectTreeRadio
  },

  data() {
    return {
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
        queryConditions: "",
        order: 1, // 0正序 1倒叙
        columnName: "creation_time,update_time",
        cooperationStatus: "", // 合作状态
        industrialChainId: "", // 产业类别
        techIdName: "", // 技术类别
        size: "", // 所选条数
        industryTag: [], // 行业类别
        solutionType: "", // 解决方案类别
        deliveryType: [] // 交付类型
      },
      enterpriseTable: [],
      company: {
        code: [], // 单选删除
        multiCode: [] // 多选删除
      },
      tags: [
        {
          name: "行业类别",
          tagName: "industryTag",
          valLength: 0
        },
        {
          name: "方案类型",
          tagName: "solutionType"
        },
        {
          name: "交付类型",
          tagName: "deliveryType",
          valLength: 0
        }
      ],
      valueI: 0
    };
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem("token");
    },
    enterpriseType() {
      return this.$route.params.enterpriseType;
    }
  },
  async created() {
    this.search();
  },
  methods: {
    fileClick() {
      this.search();
    },
    popoverClick(val) {
      if (val === "all") {
        Object.assign(this.queryInfo, { companyCode: [], size: "" });
      } else if (val == 0 && this.queryInfo.companyCode.length) {
        Object.assign(this.queryInfo, {
          companyCode: this.queryInfo.companyCode
        });
      } else {
        Object.assign(this.queryInfo, { size: val });
      }

      exportData(
        this.queryInfo, // 后台需要的参数
        "/company/exportExcel", // 路径
        "application/msexcel", // 下载的文件类型
        this.search, // 下载完之后调查询方法
        "企业数据.xls"
      );
    },
    // 查询条件更变 recode
    labelTagChange(key, value, name) {
      const index = this.tags.findIndex(el => {
        return el.tagName === key;
      });

      if (index !== -1) {
        let tagItem = this.tags[index];

        if (tagItem.hasOwnProperty("valLength")) {
          this.setTagValue(tagItem, value, true);
        } else {
          this.setTagValue(tagItem, value, false);
        }

        this.search();
      } else {
        let tempObj = {
          name,
          tagName: key
        };

        if (Array.isArray(value)) {
          tempObj.valLength = 0;
        }

        this.tags.push(tempObj);
      }
    },
    setTagValue(tagItem, value, flag) {
      if (flag) {
        if (Array.isArray(value) && value.length) {
          this.$set(tagItem, "field", value[0]);
          tagItem.valLength = value.length - 1;
        } else {
          this.$set(tagItem, "field", "");
          tagItem.valLength = 0;
        }
      } else {
        if (value) {
          this.$set(tagItem, "field", value);
        } else {
          this.$set(tagItem, "field", "");
        }
      }
    },
    // tag标签关闭
    closeTag(index, name) {
      this.tags.splice(index, 1);

      switch (name) {
        case "industryTag":
          this.queryInfo.industryTag = [];
          break;
        case "solutionType":
          this.queryInfo.techIdName = "";
          break;
        case "deliveryType":
          this.queryInfo.deliveryType = [];
          break;
        default:
          this.queryInfo[name] = "";
          break;
      }
      this.search();
    },

    // 查询
    async search() {
      const res = await getSolutionList(this.queryInfo);
      if (res.code === 200) {
        this.enterpriseTable = res.data.list;
        this.total = res.data.total;
      }
    },
    // 多选
    handleSelectionChange(val) {
      this.company.multiCode = val.map(item => {
        return item.id;
      });

      this.queryInfo.companyCode = val.map(item => {
        return item.id;
      });
    },
    // 多选删除
    multiDelete() {
      if (this.company.multiCode.length > 1) {
        this._deleteCompany(this.company.multiCode);
      } else {
        this.$message.error("批量删除必须大于一条");
      }
    },
    // 单选删除
    deleteItem(row) {
      this.company.code.push(row.id);

      this._deleteCompany(this.company.code);
    },
    _deleteCompany(params) {
      this.$confirm("确认删除吗 ?", "提示")
        .then(async () => {
          const res = await deleteSolutionById(params);

          if (res.code === 200) {
            this.$message.success("删除成功");
            this.search();
          }
        })
        .catch(() => {});
    },
    //下载产品附件
    async downloadClick(row) {
      const URL = "http://175.24.131.212:9506/";

      if (row.productFile) {
        const productFiles = row.productFile.substring(
          row.productFile.lastIndexOf("/") + 1
        );
        axios({
          method: "GET",
          url: `${URL}system/public/downloadUrlFile`,
          params: { urlStr: "http://" + row.productFile },
          responseType: "blob",
          headers: {
            // 设置请求头
            Authorization: this.Authorization
          }
        })
          .then(res => {
            let blob = new Blob([res.data], {
              type: "application/msword"
            });
            let href = window.URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
            const a = document.createElement("a"); //创建a标签
            a.style.display = "none";
            a.href = href; // 指定下载'链接
            a.download = productFiles + ".pdf"; //指定下载文件名
            a.click(); //触发下载
            URL.revokeObjectURL(a.href); //释放URL对象
            document.body.removeChild(a); //释放标签
          })
          .catch(err => {
            //this.$message.error('文件下载失败')
          });
      } else {
        this.$message("该条数据没有附件！");
      }
    },
    // 领域技术类别
    set_cell_style({ row, column, rowIndex, columnIndex }) {
      if (column.label === "领域类别" || column.label === "技术类别") {
        return "cursor:pointer;";
      }
    },
    // 字符串格式化成数组
    formatString(val) {
      if (!val) {
        return [];
      } else if (!val.length) {
        return val;
      } else {
        return val.split(",");
      }
    },
    // 编辑
    editItem(row) {
      console.log(row);
      let text = this.$router.resolve({
        path: "/solvePlan/solvePlanInfo",
        query: {
          companyCode: row.id,
          enterpriseType: 1,
          queryInfo: this.queryInfo,
          id: row.id,
          headTabActive: 0,
          type: 2
        }
      });
      window.open(text.href, "_blank");
    },
    // 点击文字切换正倒序
    caretText() {
      switch (this.valueI) {
        case 0:
          this.queryInfo.columnName = "creation_time";
          this.queryInfo.order = 1;
          this.valueI++;
          break;
        case 1:
          this.queryInfo.columnName = "creation_time";
          this.queryInfo.order = 0;
          this.valueI++;
          break;
        case 2:
          this.queryInfo.columnName = "creation_time,update_time";
          this.queryInfo.order = 1;
          this.valueI = 0;
          break;
      }
      this.search();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
    },
    // 正序
    caretTop() {
      // this.queryInfo.order = 0;
      // this.search();
    },
    // 倒序
    caretBottom() {
      // this.queryInfo.order = 1;
      // this.search();
    },
    // 数据完整度排序
    sortChange(column) {
      console.log(column);
      this.pageNum = 1;
      if (column.prop === "companyDataIntegrity") {
        this.queryInfo.columnName = "company_data_integrity";
        if (column.order === "ascending") {
          this.queryInfo.order = 0;
        } else if (column.order === "descending") {
          this.queryInfo.order = 1;
        } else {
          this.queryInfo.order = 1;
          this.queryInfo.columnName = "creation_time,update_time";
        }
      } else if (column.prop === "solutionDataIntegrity") {
        this.queryInfo.columnName = "solution_data_integrity";
        if (column.order === "ascending") {
          this.queryInfo.order = 0;
        } else if (column.order === "descending") {
          this.queryInfo.order = 1;
        } else {
          this.queryInfo.order = 1;
          this.queryInfo.columnName = "creation_time,update_time";
        }
      } else if (column.prop === "companyCode") {
        this.queryInfo.columnName = "company_code";
        if (column.order === "ascending") {
          this.queryInfo.order = 0;
        } else if (column.order === "descending") {
          this.queryInfo.order = 1;
        } else {
          this.queryInfo.order = 1;
          this.queryInfo.columnName = "creation_time,update_time";
        }
      }
      this.search();
    }
  }
};
</script>

<style lang="less" scoped>
.enterprise {
  /deep/ .el-input-group__append {
    background: #1e9fff;
    color: #fff;
    border: 1px solid #1e9fff;
  }
  .caretTime:hover {
    cursor: pointer;
  }
}
/deep/ .filterInfo .el-form-item__content {
  padding: 0;
}
/deep/ .el-image__inner {
  border-radius: 5px;
}
.isActiveTime {
  color: #1e9fff !important;
}
.iconColor {
  color: #c0c4cc !important;
}
</style>
